import * as React from "react";
import type { SVGProps } from "react";
const SvgImageQuestion = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m6 22.2 10.2-9.6 4.8 4.8M6 22.2h12a3.6 3.6 0 0 0 3.6-3.6V12M6 22.2a3.6 3.6 0 0 1-3.6-3.6v-12A3.6 3.6 0 0 1 6 3h6.6m4.2 1.148c0-1.297 1.075-2.348 2.4-2.348 1.326 0 2.4 1.051 2.4 2.348s-1.075 2.348-2.4 2.348m0 3.194V9.6M9.6 8.4a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0"
    />
  </svg>
);
export default SvgImageQuestion;
